import io from "socket.io-client";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Form, ListGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { RoomContext } from "../App";
import { NicknameContext } from "../App";
import { socket } from "../App";
import "../index.css";
import { signOut } from "firebase/auth";

import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import {collection} from "firebase/firestore"


import { InputGroup } from "react-bootstrap";
import { Game } from "./game";
import { RoomMenu } from "./roommenu";
import { Lobby } from "./lobby";
import { Card } from "react-bootstrap";
import previewGif from "../gamePreview.gif";
import { Image } from "react-bootstrap";

import  pinkPenguin from "../pinkPenguin.webp";
import sketchPenguin from "../penguin-drawing.jpg"
import pinkCloud from "../pinkCloud.png"
import {UserContext} from "../App"
import {db} from "../firebase"
import { doc, getDoc, addDoc, getDocs, updateDoc } from "firebase/firestore";
import {query,where} from "firebase/firestore"
import {Dropzone, FileMosaic} from "@files-ui/react"
import { InputFilesContext } from "../App";



export const FusePage = () => {

    const [waiting, setWaiting] = useState(false);
    const [splashResult, setSplashResult] = useState(null);
    const [error, setError] = useState(null);

    const [displayFeedback, setDisplayFeedback] = useState(false);
    const {inputFiles, setInputFiles} = useContext(InputFilesContext)

    const {user} = useContext(UserContext)
    const [displaySave, setDisplaySave] = useState(false);

  //  const [inputFiles, setInputFiles] = useState([]);

    const [files, setFiles] = useState([]);

    const updateFiles = (files) => {
        setInputFiles(files);
    }

    const [url, setUrl] = useState(null);


    useEffect(() => {
        console.log(inputFiles)
        socket.on("splash_result", (data) => {
          console.log(data)
          setDisplaySave(true);
          if (data.message) {
            setError(true);
            setWaiting(false);
            setSplashResult("fail");
          } else {
            //    console.log(data);
            console.log(inputFiles)
            console.log(data.url)
            setSplashResult(data.url);
           setDisplayFeedback(true);
            setWaiting(false);
            setUrl(data.url);
            handleSave(data.url);
         //   setInputFilesFirestore(data.inputFilesFirestore)
         
    
          /*  socket.emit("splash_feedback", {
              email: user.email || "beta",
              input: files,
              feedback: "auto",
              splashResult: splashResult,
            });*/
          }
        });
    
        return () => {
          socket.off("splash_result");
        };
      });

      const handleNew = () => {
        setSplashResult(null);
        setError(false);
        setInputFiles([]);
        setResultId(null);
    
        fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const file = new File([blob], "fusion.png", { type: "image/png" });
          setInputFiles([{file: file, id: 12, size: file.size, type: "image/png", name: file.name}]);
          console.log(file,blob)
        })
        .catch(error => console.error(error));
      };

      const [resultId, setResultId] = useState(null);

    const handleSave = async (splashResultUrl) => {
        console.log(files)
        socket.emit("save_fusion", { email: user.email, inputFiles: files, splashResult: splashResultUrl,
        nickname: user.displayName }, (data) => {
          setResultId(data.id);
          console.log(data)
        });
        setDisplaySave(false);
    /*    const q = query(collection(db, "posts"), where("id", "==", splashResult));
        console.log(q)
        const querySnapshot = await getDocs(q);
        if (querySnapshot.docs.length > 0) {
          alert("This image has already been saved.");
          return;
        }
        const docRef = await addDoc(collection(db, "posts"), {
          id: splashResult,
          imgUrl: splashResult,
          type: "fusion",
          nickname: user.displayName,
          timestamp: Date.now(),
        });
        alert("Saved!");*/
    };

   
    const handleSplash = async () => {
        //   alert(`You have reached the default limit of games. (there's a limit to prevent too much server load) 
        //   If you actually like the game, contact me eero.the.engineer@gmail.com and I'll give you more.`);
          // return;
          if (!inputFiles) {
           return;
          }
          console.log(inputFiles)
           const filesArr = Array.from(inputFiles);
           const files = filesArr.map((file) => ({
             data: file.file,
             type: file?.file.type.split("/")[1],
             original: file?.original == true,
             url: file?.url,
             fid: file?.id,
           }));
           //   console.log(files);
           setWaiting(true);
           setFiles(files);
       
           const q = query(collection(db, "users"), where("name", "==", user.email));
           const querySnapshot = await getDocs(q);
       
           const limit = querySnapshot.docs[0].data().limit;
           await updateDoc(doc(db, "users", querySnapshot.docs[0].id), {
             limit: limit - 1,
           });
           console.log(files)
           socket.emit("splash", { email: user.email, files: files });
         };
       

         const handleFeedback = (feedback) => {
           setDisplayFeedback(false);
           // console.log(feedback, user.email, files, splashResult)
           console.log(resultId)
           socket.emit("splash_feedback", {
             email: user.email || "beta",
             feedback: feedback,
             docId: resultId,
           });
         };

    return (
        <div>
            <h1>Fusion tool</h1>

            
      {true && (
        <>
          {!waiting && !splashResult && !error && (
            <Form style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ textAlign: "left" }}>
                You can select multiple images here, the images will then be
                fused together.
              </div>
              <br />
              <div style={{ textAlign: "left" }} className="mt-2">
                <strong>Tip: </strong>
                Try to find funny/cool images on your camera roll. (that are not
                personal)
              </div>
              <div style={{ textAlign: "left" }} className="mt-2">
                For example: <em>a sunset + album cover</em>,<br /> or
                <em> iconic photo 1 + iconic photo 2</em>
              </div>

              <Dropzone 
              header={true}
              footer={false}
              value={inputFiles}
              onChange={updateFiles}
             >
              
                {inputFiles.map(((file,index) => (
                  <FileMosaic {...file} key={index} preview/>
                )))}
              </Dropzone>
              

            {/*}  <FormControl
                id="formControlsFile"
                type="file"
                multiple
                label="File"
                ref={fileInputRef}
                />*/}
              <Button
                className="mt-3"
                variant="light"
                style={{ width: "fit-content" }}
                onClick={() => handleSplash()}
              >
                Fuse
                </Button>
            </Form>
          )}
          {waiting && (
            <div>
              Fusing... <br /> 
              <div>
        {/*}      <strong>Tip: </strong>Create a fusion chain by fusing the result with another image.*/}
                </div>
            </div>
          )}
        </>
      )}
            {!waiting && splashResult && !error && (
        <div className="d-flex flex-column align-items-start">
          <Image src={splashResult} size="md" fluid />

          <Container className="mt-3" style={{display:"flex", gap: "10px"}}>
          <Button
            variant="light"
            onClick={() => {
              handleNew();
            }}
          >
            New
          </Button>
          {displaySave && <Button variant="light" onClick={() => handleSave()}>Save</Button>}
          </Container>
        
          {displayFeedback && (
            <div className="mt-3">
              <strong>Rate:</strong> (this improves the tool) <br />
              <Button variant="light" onClick={() => handleFeedback("good")}>
                Wow!
              </Button>
              <Button variant="light" onClick={() => handleFeedback("bad")}>
                Meh
              </Button>
            </div>
          )}
        </div>

        
      )}
    {!waiting && splashResult && error && (
        <>
          <div>There was an error with the final image :( </div>
          <div>(this can happen if the input images contain celebrities)</div>
          <Button
            variant="light"
            onClick={() => {
              setSplashResult(null);
              setFiles([]);
              setError(false);
            }}
          >
            New
          </Button>
        </>
      )}
        </div>
    )
}




























